import { render, staticRenderFns } from "./ComplaintChangeActivationType.vue?vue&type=template&id=33888ec4&"
import script from "./ComplaintChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ComplaintChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports